export const PRESETS = {
  SKILLS_MATRIX: 'SKILLS_MATRIX',
  COMPETENCE_MAP: 'COMPETENCE_MAP',
  GENERAL_MOOD: 'GENERAL_MOOD',
  ATTRIBUTE: 'ATTRIBUTE',
  COMPARE: 'COMPARE',
  DASHBOARD: 'DASHBOARD',
  ABSENCE_CALENDAR: 'ABSENCE_CALENDAR',
};
